export default {
  install(Vue) {
    // 全局指令 v-wechat-title="'页面标题'"
    // keep-alive 缓存页失活后仍可能因 $route 变化触发 update，需跳过以免覆盖当前页标题
    function isCurrentPage(el, vnode) {
      if (!vnode || !vnode.context || !vnode.context.$route) return false
      // keep-alive 失活实例
      if (vnode.context._inactive) return false
      // 指令绑定时所在路由，与当前路由不一致则忽略（防止缓存页误改标题）
      if (el.__wechat_title_route__ !== vnode.context.$route.name) return false
      return true
    }

    function setTitle(binding) {
      if (binding && binding.value) {
        window.document.title = binding.value
      } else {
        window.document.title = ' '
      }
    }

    Vue.directive('wechat-title', {
      inserted(el, binding, vnode) {
        if (vnode && vnode.context && vnode.context.$route) {
          el.__wechat_title_route__ = vnode.context.$route.name
        }
        if (!isCurrentPage(el, vnode)) return
        setTitle(binding)
      },
      update(el, binding, vnode) {
        if (!isCurrentPage(el, vnode)) return
        if (vnode.context.$route.meta) {
          vnode.context.$route.meta.isCustomTitle = 1
        }
        if (binding && binding.value) {
          window.document.title = binding.value
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/plugins/vue-wechat-title.js